const wrapperStyle = {
  margin: "0 auto",
  maxWidth: "1160px",
};

const sixColumnStyle = {
  m: 1,
  width: ["100%", "calc(50% - 20px)", "calc(16% - 20px)"],
};

const fiveColumnStyle = {
  m: 1,
  width: ["100%", "calc(50% - 20px)", "calc(20% - 20px)"],
};

const fourColumnStyle = {
  m: 1,
  width: ["100%", "calc(50% - 20px)", "calc(25% - 20px)"],
};

const twoColumnStyle = {
  m: 1,
  width: ["100%", "calc(50% - 20px)"],
};

export {
  wrapperStyle,
  fourColumnStyle,
  twoColumnStyle,
  sixColumnStyle,
  fiveColumnStyle,
};
